"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewHeaderLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const FlexBox_1 = require("../FlexBox");
const respinner_1 = require("respinner");
const lib_1 = require("../../lib");
const CircularLoader = respinner_1.CircularLoading;
const ViewHeaderLoader = ({ label, className, delay, }) => {
    const [show, setShow] = (0, react_1.useState)(delay === undefined);
    function handleDelay() {
        setShow(true);
    }
    (0, react_1.useEffect)(() => {
        if (delay !== undefined) {
            const timeout = setTimeout(handleDelay, delay);
            return () => {
                clearTimeout(timeout);
            };
        }
    }, []);
    if (!show) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(FlexBox_1.FlexBox, Object.assign({ alignItems: "center", className: className }, { children: [(0, jsx_runtime_1.jsx)(CircularLoader, { duration: 1, size: 15, className: (0, lib_1.classnames)((0, lib_1.bem)("spinner__svg", "--circular", "--view-header"), (0, lib_1.use)(label, "mr--0_5")) }, void 0), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "type--0_875 type--s075 type--default" }, { children: label }), void 0)] }), void 0));
};
exports.ViewHeaderLoader = ViewHeaderLoader;
//# sourceMappingURL=ViewHeaderLoader.js.map